module.exports = __webpack_public_path__ + "img/v1.c51cc6d9.png";